import { useEffect, useState } from 'react';
import { ButtonGroupButton, ButtonGroupButtonProps } from '../button-group-button/ButtonGroupButton';

export interface ButtonGroupProps {
  defaultIndex?: number;
  buttons: ButtonGroupButtonProps[];
  className?: string;
  disabled?: boolean;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({ defaultIndex = 0, buttons, className, disabled = false }) => {
  const [activeButton, setActiveButton] = useState<number>(defaultIndex);

  useEffect(() => {
    setActiveButton(defaultIndex);
  }, [defaultIndex]);

  return (
    <span className={className}>
      {buttons.map((button: ButtonGroupButtonProps, index: number) => (
        <ButtonGroupButton
          key={button.id}
          {...button}
          disabled={disabled}
          isActive={activeButton === index}
          onClick={() => {
            setActiveButton(index);
            button.onClick();
          }}
        />
      ))}
    </span>
  );
};

export default ButtonGroup;
